<template>
  <div class="coupon-preview">
    <div v-if="visibleCoupons.length" class="coupon-scroll" :class="$$FormData.layout || 'horizontal'">
      <div
        v-for="coupon in visibleCoupons"
        :key="coupon.coupon_id"
        class="coupon-card"
        :class="[$$FormData.card_style || 'style-3', { unavailable: unavailable(coupon) }]"
        :style="cardStyle"
      >
        <div class="coupon-value">{{ couponValue(coupon) }}</div>
        <div class="coupon-condition">{{ thresholdText(coupon) }}</div>
      </div>
    </div>
    <div v-else class="coupon-empty">
      <i class="el-icon-tickets"></i>
      <span>暂无可展示优惠券，点击模块进行配置</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CouponPreview',
  computed: {
    sourceCoupons() {
      return Array.isArray(this.$$FormData.coupon_list) ? this.$$FormData.coupon_list : []
    },
    visibleCoupons() {
      return this.$$FormData.hide_unavailable ? this.sourceCoupons.filter(coupon => !this.unavailable(coupon)) : this.sourceCoupons
    },
    cardStyle() {
      return { color: this.$$FormData.theme_color || '#ff4d35', borderColor: this.$$FormData.theme_color || '#ff4d35' }
    }
  },
  methods: {
    unavailable(coupon) {
      const now = Math.floor(Date.now() / 1000)
      const manualClaimEnabled = coupon.manual_claim_enabled === true || Number(coupon.manual_claim_enabled) === 1
      const supportedType = ['FREE_GET', 'ACTIVITY_GIVE', 'POINT_EXCHANGE'].includes(coupon.type)
      const localCoupon = !coupon.data_source || coupon.data_source === 'LOCAL'
      return !manualClaimEnabled || !supportedType || !localCoupon || coupon.use_channel === 'OFFLINE' || (coupon.start_time && Number(coupon.start_time) > now) || (coupon.end_time && Number(coupon.end_time) < now) || Number(coupon.create_num || 0) <= Number(coupon.received_num || 0)
    },
    couponValue(coupon) {
      return coupon.discount_type === 'DISCOUNT' ? `${coupon.coupon_price}折` : `${coupon.coupon_price}元`
    },
    thresholdText(coupon) {
      const value = Number(coupon.coupon_threshold_price || 0)
      return value > 0 ? `满${value}元可用` : '全部商品无门槛'
    }
  }
}
</script>

<style scoped>
.coupon-preview { padding: 8px 10px; overflow: hidden; background: #fff; }
.coupon-empty { display: flex; align-items: center; justify-content: center; gap: 7px; min-height: 64px; color: #909399; font-size: 12px; border: 1px dashed #dcdfe6; background: #fafafa; box-sizing: border-box; }
.coupon-empty i { font-size: 18px; }
.coupon-scroll { display: flex; gap: 7px; min-width: 100%; }
.coupon-scroll.horizontal { width: max-content; }
.coupon-scroll.single,.coupon-scroll.two,.coupon-scroll.three { flex-wrap: wrap; width: 100%; }
.coupon-card { position: relative; flex: 0 0 102px; min-width: 102px; padding: 9px 7px 8px; text-align: center; background: #fff8f6; border: 2px solid; box-sizing: border-box; }
.coupon-scroll.single .coupon-card { flex-basis: 100%; }
.coupon-scroll.two .coupon-card { flex-basis: calc(50% - 4px); min-width: 0; }
.coupon-scroll.three .coupon-card { flex-basis: calc(33.333% - 5px); min-width: 0; }
.coupon-card::before,.coupon-card::after { content: ''; position: absolute; top: 50%; width: 8px; height: 8px; margin-top: -4px; background: #fff; border-radius: 50%; }
.coupon-card::before { left: -5px; }
.coupon-card::after { right: -5px; }
.coupon-card.style-2,.coupon-card.style-5 { border-radius: 8px; }
.coupon-card.style-4,.coupon-card.style-8 { border-style: dashed; }
.coupon-card.style-6 { box-shadow: 0 2px 7px rgba(0,0,0,.12); }
.coupon-card.style-7 { border-radius: 18px; }
.coupon-card.unavailable { filter: grayscale(1); opacity: .55; }
.coupon-value { font-size: 18px; line-height: 24px; white-space: nowrap; }
.coupon-condition { margin-top: 3px; font-size: 9px; white-space: nowrap; }
</style>
